/*
 * Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import {
  APPLICATION_STATUS_DESCRIPTION,
  APPLICATION_STATUS_DOCUMENTS,
  APPLICATION_STATUS_DONE,
  APPLICATION_STATUS_INSURANCE,
  APPLICATION_STATUS_PERSONAL,
} from "./applicationStatus";
import React from "react";
import { Navigate } from "react-router-dom";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import progressBarsteps from "./progressBarSteps";
import PersonalTextMessage from "../../components/Form/Common/PersonalTextMessage/PersonalTextMessage";
import Insurance from "../../components/Form/Common/Insurance/Insurance";
import { getCaseLink } from "../productService";
import Documents from "../../components/Form/Common/Documents/Documents";
import Personal from "../../components/Form/Common/Personal/Personal";
import { FormSteps } from "../../types/FormServiceBase";

const formSteps: FormSteps = {
  [APPLICATION_STATUS_DESCRIPTION]: {
    title: "Antrag - Ihr Anliegen | Legalbird",
    applicationStatus: APPLICATION_STATUS_DESCRIPTION,
    stepUrl: "anliegen",
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"description"} progress={11} />
        <PersonalTextMessage {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_DOCUMENTS]: {
    title: "Antrag - Dokumente | Legalbird",
    applicationStatus: APPLICATION_STATUS_DOCUMENTS,
    stepUrl: "unterlagen",
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"documents"} progress={35} />
        <Documents {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_PERSONAL]: {
    title: "Antrag - Persönliche Angaben | Legalbird",
    applicationStatus: APPLICATION_STATUS_PERSONAL,
    stepUrl: "persoenliche-angaben",
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"personal"} progress={62} />
        <Personal {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_INSURANCE]: {
    title: "Antrag - Versicherung | Legalbird",
    applicationStatus: APPLICATION_STATUS_INSURANCE,
    stepUrl: "versicherung",
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"insurance"} progress={86} />
        <Insurance {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_DONE]: {
    title: "Mein Fall | Legalbird",
    applicationStatus: APPLICATION_STATUS_DONE,
    stepUrl: "mein-fall",
    render: ({ product }) => <Navigate to={getCaseLink(product)} />,
  },
};

export default formSteps;
